/**
 * <UploadPhase> — the first half of AutoReconcileDialog: pick account + file
 * and submit to /reconcile/match. Pure view: state lives in the hook.
 */
import React from 'react';
import { Upload, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const UploadPhase = ({
  accounts,
  accountId,
  setAccountId,
  file,
  setFile,
  fileInputRef,
  matching,
  onMatch,
  onCancel,
}) => (
  <div className="space-y-4">
    <div>
      <Label>Account</Label>
      <Select value={accountId} onValueChange={setAccountId}>
        <SelectTrigger className="mt-1.5" data-testid="auto-reconcile-account-select">
          <SelectValue placeholder="Choose an account…" />
        </SelectTrigger>
        <SelectContent>
          {accounts.map((a) => (
            <SelectItem key={a.account_id} value={a.account_id}>{a.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>

    <div>
      <Label>Statement file (CSV or Excel)</Label>
      <input
        ref={fileInputRef}
        type="file"
        accept=".csv,.xlsx,.xls"
        onChange={(e) => setFile(e.target.files?.[0] || null)}
        className="mt-1.5 block w-full text-sm text-[#475569] file:mr-3 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-[#F1F5F9] file:text-[#020617] hover:file:bg-[#E2E8F0]"
        data-testid="auto-reconcile-file-input"
      />
      <p className="mt-1.5 text-xs text-[#64748B]">
        Expected headers: <code>date</code>, <code>description</code> (or <code>memo</code>), <code>amount</code>.
        Negative amounts are treated as expenses.
      </p>
    </div>

    <div className="flex gap-2 pt-2">
      <Button
        type="button"
        onClick={onMatch}
        disabled={matching || !file || !accountId}
        className="flex-1 bg-[#0052FF] text-white hover:bg-[#003ECC]"
        data-testid="auto-reconcile-match-button"
      >
        {matching ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Upload className="w-4 h-4 mr-2" />}
        {matching ? 'Matching…' : 'Match against my transactions'}
      </Button>
      <Button type="button" onClick={onCancel} className="bg-[#F1F5F9] text-[#020617] hover:bg-[#E2E8F0]">
        Cancel
      </Button>
    </div>
  </div>
);

export default UploadPhase;
